module.exports = __webpack_public_path__ + "VN.png?ee1b946d8de8ad10b56f7f11a129b812";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/VN.png
// module id = 417
// module chunks = 0